import React from "react";
import { toast } from "react-toastify";

const DocumentDetailsOffcanvas = ({
  isOpen,
  handleClose,
  selectedDoc,
  formDetails,
  loading,
  commonFields,
  handleEditDetails,
}) => {
  return (
    <div
      className={`offcanvas offcanvas-end ${isOpen ? "show" : ""}`}
      tabIndex="-1"
      id="detailsOffcanvas"
      style={{ visibility: isOpen ? "visible" : "hidden", minWidth: "50%" }}
    >
      <div className="offcanvas-header">
        <h5 className="offcanvas-title">
          Details for {selectedDoc?.file_name}
        </h5>
        <button
          type="button"
          className="bg-transparent"
          onClick={handleClose}
        >
          <i className="bi bi-x-circle"></i>
        </button>
      </div>
      <div className="offcanvas-body">
        {loading ? (
          <p>Loading details...</p>
        ) : (
          <>
            <table className="table table-bordered">
              <thead className="thead-light">
                <tr>
                  <th scope="col" style={{ width: "40%" }}>
                    Field
                  </th>
                  <th scope="col" style={{ width: "60%" }}>
                    Value
                  </th>
                </tr>
              </thead>
              <tbody>
                {commonFields.map((field) => (
                  <tr key={field.name}>
                    <td>{field.label}</td>
                    <td>{formDetails[field.name] || "-"}</td>
                  </tr>
                ))}
                {formDetails.additional_data &&
                  Object.entries(formDetails.additional_data).map(
                    ([key, value]) => (
                      <tr key={key}>
                        <td>
                          {key
                            .replace(/_/g, " ")
                            .replace(/\b\w/g, (c) => c.toUpperCase())}
                        </td>
                        <td>{value || "-"}</td>
                      </tr>
                    )
                  )}
              </tbody>
            </table>
            <div className="mt-4">
              <button
                className="btn btn-primary me-2"
                onClick={() => {
                  if (!selectedDoc) {
                    toast.error("No document selected to edit.");
                    return;
                  }
                  handleEditDetails(selectedDoc, formDetails);
                }}
              >
                Edit Details
              </button>
              <button
                className="btn btn-secondary"
                onClick={handleClose}
              >
                Close
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default DocumentDetailsOffcanvas;
